import { applyAction } from "./appliers";
import type { CarnivalAction, CarnivalGameState } from "./types";
import { validateAction } from "./validators";

export interface ReduceResult {
  readonly state: CarnivalGameState;
  readonly accepted: boolean;
  readonly error?: string;
}

export function reduceGameState(
  state: CarnivalGameState,
  action: CarnivalAction,
): CarnivalGameState {
  return applyAction(state, action);
}

export function validateAndReduceGameState(
  state: CarnivalGameState,
  action: CarnivalAction,
): ReduceResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return { state, accepted: false, error: validation.error };
  }
  return { state: reduceGameState(state, action), accepted: true };
}
